import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';
import {
    FormatChooser,
    formatIsCustomizable,
    IFormatChooserValue
} from '../../../../_common/platform/tsx/FormatChooser';

import AttributeDesigner, {
    ITreeItem,
    IToggleStates
} from '../../../../_common/platform/tsx/attributeDesigner/AttributeDesigner';
import SelectField from '../../../../_common/platform/tsx/SelectField';

import AttributeSortingSelect, {
    AttributeSortingSelectHeader,
    normalizeSorting,
    processSortSet
} from '../../../../_common/platform/tsx/AttributeSortingSelect';

import { AGGREGATE_GROUP_VALUES } from '../../../../_common/application/ts/ConfigurationConstants';

import {
    ATTRIBUTE_TYPES,
    FORMATS,
    IFormatElement,
    TIME_PART_FORMAT_ELEMENTS
} from '../../../../_common/platform/ts/ConfigurationConstants';

import { IExpression, DataloadEventTypes } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

import * as AttrQueryValuesFormat from '../../../../_common/platform/ts/AttrQueryValuesFormat';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import { IntervalsSelect } from '../../../../_common/platform/tsx/IntervalsSelect';
import { DiscreteIntervalsKind } from '../../../../_common/platform/tsx/DiscreteIntervals';
import AttributeOptionsSelect from './AttrOptionsSelect';
import StringField from '../../../../_common/platform/tsx/StringField';

import { IAttrQuery, STANDARD_ROLE, CARD_TYPE_ENUM } from './Interfaces';

import { ATTRIBUTE_CONTROL_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';

import {
    SuggestionSelect,
    GetValuesResult,
    IGetValuesResult,
    ISuggestionValue,
    convertFromHashToDisplayValues
} from '../../../../_common/platform/tsx/SuggestionSelect';

import { IDisplayValue } from '../../../../_common/platform/ts/Interfaces';
import { makeDefaultCustomID, normalizeCustomID } from '../../../../_common/platform/ts/Utilities';
import { IAttributeName } from '../../../../_common/platform/tsx/filtering/Interfaces';

const STANDARD_ROLES: STANDARD_ROLE[] = [
    'ID',
    'baseForDiff',
    'valueForDiff',
    'top2toDiff',
    'deltaAbsolute',
    'deltaPercent',
    'deltaIcon',
    'deltaColor',
    'title',
    'subtitle'
];

interface AttrQueryFieldProperties {
    value?: IAttrQuery[];
    themeObj?: any;
    dataSourceID: number;
    query_num?: number;
    validEntities: string[];
    tabID: number;
    options: any;
    glob: IGlob;

    onChange(value: IAttrQuery[]): void;
}

function getAttributeType(value: string | IAttributeName, glob: IGlob, dataSourceID: number) {
    if (value == null) {
        return null;
    }

    const attribute = typeof value === 'string' ? value : value.attribute;

    if (attribute === '#Delta' || attribute === '#DeltaPCT') {
        return ATTRIBUTE_TYPES.REAL;
    } else {
        return glob.EntityModelsStore.getAttributeType(value, dataSourceID);
    }
}

function getDefaultAttributeType(value: string | IAttributeName, glob: IGlob, dataSourceID: number) {
    if (value == null) {
        return null;
    }

    const attribute = typeof value === 'string' ? value : value.attribute;

    if (attribute === '#Delta' || attribute === '#DeltaPCT') {
        return ATTRIBUTE_TYPES.REAL;
    } else {
        return glob.EntityModelsStore.getDefaultAttributeType(value, dataSourceID);
    }
}

class AttrQueryFieldRow extends React.Component<
    {
        dataSourceID?: number;
        dataSourceID1?: number;
        value?: IAttrQuery;
        theme?: any;
        index?: number;
        maxIndex?: number;
        tabID: number;

        customRoles: string[];
        RoleValuesList?: any;
        Role_TemplateID?: any;
        query_num?: number;
        RoleValuesListFull?: any;

        hasTooltipRole?: boolean;
        defaultColor?: string;
        validEntities: string[];

        isEmpty?: boolean;

        entitiesTree: ITreeItem[];
        entityCollapsedDict: IToggleStates;
        cardType?: CARD_TYPE_ENUM;
        glob: IGlob;

        onEntityCollapsedDictChange?(value): void;
        onAdd?(value: string[], expression: IExpression, variable): void;
        onAddCustomRole?(role: string): void;
        onChange?(value: IAttrQuery, index): void;
        onRemove?(index): void;
        onSortSet?(index, value: IAttrQuery): void;
    },
    {
        customRoles: string[];
    }
> {
    constructor(props) {
        super(props);

        this.state = {
            customRoles: this.props.customRoles
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (_.isEqual(nextProps.customRoles, prevState.customRoles)) {
            return null;
        } else {
            return {
                customRoles: nextProps.customRoles
            };
        }
    }

    getValueCopy(): IAttrQuery {
        return _.clone(this.props.value || {}) as IAttrQuery;
    }

    normalize(value: IAttrQuery) {
        if (value.templateID != null) {
            value.templateID = normalizeCustomID(value.templateID);

            if (value.templateID == null) {
                delete value.templateID;
            }
        }

        if (value.attribute == null && value.expression == null) {
            delete value.aggregateGroup;
            delete value.intervals;
            delete value.label;
            delete value.templateID;
            delete value.role; //LL: ~~ axis
            delete value.formatFront;
            delete value.currency;
            delete value.customFormat;
            delete value.precision;
            delete value.useDigitGrouping;
            delete value.overwriteInheritedUseDigitGrouping;
            delete value.formatZeroAsBlank;
            delete value.overwriteInheritedFormatZeroAsBlank;
            delete value.customStyle;
            delete value.template;
            delete value.cellStyle;
            delete value.mapping;
            delete value.clickToFilterAttribute;
            delete value.sort;
            delete value.sortOrder;
            delete value.sortOnValues;
            return;
        }

        if (value.attrType != null) {
            delete value.attrType;
        }

        if (value.sort != null && value.sortOnValues == null) {
            value.sortOnValues = false; // WorkItem [102543]: Do not set "sort on value" by default when sorting for attribute is not 'none'
        }

        if (value.sort == null) {
            delete value.sortOnValues;
            delete value.sortOrder;
        }

        if (value.intervals == null) {
            delete value.intervals;
        }

        let attributeType = 'none';

        if (value.attribute === '#Delta' || value.attribute === '#DeltaPCT') {
            attributeType = value.type;
            delete value.clickToFilterAttribute;
        } else {
            attributeType = getAttributeType(value, this.props.glob, this.props.dataSourceID);

            if (attributeType == null) {
                attributeType = 'none';
            }
        }

        switch (attributeType) {
            case ATTRIBUTE_TYPES.STRING:
                if (!AttrQueryValuesFormat.isCountAggregate(value)) {
                    delete value.formatFront;
                    //delete value.intervals;
                    delete value.precision;
                    delete value.useDigitGrouping;
                    delete value.overwriteInheritedUseDigitGrouping;
                    delete value.formatZeroAsBlank;
                    delete value.overwriteInheritedFormatZeroAsBlank;
                    //delete value.mapping;
                }
                break;

            case ATTRIBUTE_TYPES.ENUMERATION:
                if (!AttrQueryValuesFormat.isCountAggregate(value)) {
                    delete value.formatFront;
                    delete value.intervals;
                    delete value.precision;
                    delete value.useDigitGrouping;
                    delete value.overwriteInheritedUseDigitGrouping;
                    delete value.formatZeroAsBlank;
                    delete value.overwriteInheritedFormatZeroAsBlank;
                    delete value.mapping;
                }
                break;

            case ATTRIBUTE_TYPES.BOOLEAN:
                if (!AttrQueryValuesFormat.isCountAggregate(value)) {
                    //delete value.formatFront;
                    delete value.intervals;
                    delete value.precision;
                    delete value.useDigitGrouping;
                    delete value.overwriteInheritedUseDigitGrouping;
                    delete value.mapping;
                }
                break;

            case 'none':
                if (
                    !(
                        AttrQueryValuesFormat.isCountAggregate(value) ||
                        (value.expression != null && value.expression.rettype !== ATTRIBUTE_TYPES.STRING)
                    )
                ) {
                    delete value.formatFront;
                    delete value.precision;
                    delete value.useDigitGrouping;
                    delete value.overwriteInheritedUseDigitGrouping;
                    delete value.formatZeroAsBlank;
                    delete value.overwriteInheritedFormatZeroAsBlank;
                    delete value.intervals;
                }
                break;
        }

        let find = _.find(AGGREGATE_GROUP_VALUES[attributeType], (val) => {
            return val === value.aggregateGroup;
        });

        if (find == null) {
            delete value.aggregateGroup;
        }

        if (value.formatFront == null) {
            value.formatFront = 'default';
        }

        if (value.formatFront != null) {
            attributeType = AttrQueryValuesFormat.getAttributeTypeByAggregate(value, attributeType);

            let formatList: IFormatElement[];

            if (
                attributeType === ATTRIBUTE_TYPES.BOOLEAN ||
                attributeType === ATTRIBUTE_TYPES.INTEGER ||
                attributeType === ATTRIBUTE_TYPES.REAL
            ) {
                formatList = FORMATS[attributeType];

                if (formatList == null) {
                    formatList = TIME_PART_FORMAT_ELEMENTS['not_set'];
                }

                let find1 = _.find(formatList, (val) => {
                    return val.value === value.formatFront;
                });

                if (find1 == null) {
                    delete value.formatFront;
                }
            }

            if (DateTimeFunctions.isTypeOfAnyDate(attributeType)) {
                var timePart;

                if (value.intervals != null) {
                    if (value.intervals.timePart != null) {
                        timePart = value.intervals.timePart;
                    }
                }

                if (timePart != null) {
                    formatList = TIME_PART_FORMAT_ELEMENTS[timePart];
                } else {
                    //type is "time":
                    if (attributeType === ATTRIBUTE_TYPES.DATE) {
                        formatList = TIME_PART_FORMAT_ELEMENTS['type_date_only'];
                    } else if (attributeType === ATTRIBUTE_TYPES.TIME) {
                        formatList = TIME_PART_FORMAT_ELEMENTS['type_time'];
                    } else {
                        formatList = TIME_PART_FORMAT_ELEMENTS['default'];
                    }
                }

                if (formatList == null) {
                    formatList = TIME_PART_FORMAT_ELEMENTS['not_set'];
                }

                let find2 = _.find(formatList, (val) => {
                    return val.value === value.formatFront;
                });

                if (find2 == null) {
                    delete value.formatFront;
                }
            }
        }
    }

    processOnAdd(checkedItems: string[], expression: IExpression, variable) {
        if (typeof this.props.onAdd === 'function') {
            this.props.onAdd(checkedItems, expression, variable);
        }
    }

    getAttributeOnChangeHandlter(isEmpty: boolean) {
        return (values: string[]) => {
            if (isEmpty) {
                this.processOnAdd(values, undefined, null);
            } else {
                const obj = this.getValueCopy();
                const newAttribute = values[0];
                const attributeType = getAttributeType(newAttribute, this.props.glob, this.props.dataSourceID);
                const oldAttributeType = getAttributeType(obj.attribute, this.props.glob, this.props.dataSourceID);

                if (attributeType !== oldAttributeType) {
                    delete obj.intervals;
                    obj.type = attributeType;
                }

                obj.attribute = newAttribute;
                obj.attrType = attributeType;
                delete obj.expression;

                this.handleOnValueChange(obj);
            }
        };
    }

    getExpressionOnChangeHandlter(isEmpty: boolean) {
        if (isEmpty) {
            return (expression: IExpression) => {
                this.processOnAdd(undefined, expression, null);
            };
        } else {
            return (expression: IExpression) => {
                const obj = this.getValueCopy();

                obj.expression = expression;
                delete obj.attribute;
                this.handleOnValueChange(obj);
            };
        }
    }

    handleOnAggregateChange = (value: string) => {
        const result = this.getValueCopy();

        if (value === 'none') {
            delete result.aggregateGroup;
        } else {
            result.aggregateGroup = value;
        }

        this.handleOnValueChange(result);
    };

    handleSortOrderChange = (value) => {
        if (typeof this.props.onSortSet === 'function') {
            this.props.onSortSet(this.props.index, value);
        }
    };

    processSortOnValuesChange = (value) => {
        const obj = this.getValueCopy();

        obj.sortOnValues = value;
        this.handleOnValueChange(obj);
    };

    processIntervalsChange = (value, withMappings) => {
        const obj = this.getValueCopy();

        if (withMappings === true) {
            //  new
            obj.intervals = value.intervals;

            if (value.mapping != null) {
                obj.mapping = value.mapping;
            } else {
                delete obj.mapping;
            }
        } else {
            // old
            obj.intervals = value;
        }

        this.handleOnValueChange(obj);
    };

    handleFormatFrontChange = (value: IFormatChooserValue) => {
        const obj = this.getValueCopy();

        if (value.formatFront == null) {
            delete obj.formatFront;
        } else {
            obj.formatFront = value.formatFront;
            obj.customFormat = value.customFormat;
            obj.currency = value.currency;
        }

        obj.precision = value.precision;
        obj.useDigitGrouping = value.useDigitGrouping;
        obj.overwriteInheritedUseDigitGrouping = value.overwriteInheritedUseDigitGrouping;
        obj.formatZeroAsBlank = value.formatZeroAsBlank;
        obj.overwriteInheritedFormatZeroAsBlank = value.overwriteInheritedFormatZeroAsBlank;
        obj.useFiscalPrefix = value.useFiscalPrefix;
        obj.fiscalYearDivider = value.fiscalYearDivider;
        obj.cellStyle = value.cellStyle;
        obj.template = value.template;
        this.handleOnValueChange(obj);
    };

    handleOnTemplateIDChange = (value: string) => {
        const valueCopy = this.getValueCopy();

        valueCopy.templateID = value;
        this.handleOnValueChange(valueCopy);
    };

    handleOnLabelChange = (value: string) => {
        const valueCopy = this.getValueCopy();

        if (value != null) {
            valueCopy.label = value;
        } else {
            delete valueCopy.label;
        }

        this.handleOnValueChange(valueCopy);
    };

    processRoleChange = (values: ISuggestionValue[]) => {
        const obj = this.getValueCopy();

        if (values == null || values.length === 0) {
            return;
        }

        const val = values[0].value;
        //var val = (ReactDOM.findDOMNode(this.refs['role']) as HTMLInputElement).value;

        if (!_.findWhere(this.props.RoleValuesList, { val: val })) {
            if (typeof this.props.onAddCustomRole === 'function') {
                this.props.onAddCustomRole(val);

                let customRoles = this.state.customRoles;

                if (!_.contains(customRoles, val)) {
                    customRoles.push(val);

                    this.setState({
                        customRoles: customRoles
                    });
                }
            }
        }

        if (obj.role != val) {
            delete obj.readOnly;

            const roleTemplateID = this.props.Role_TemplateID[this.props.cardType];

            switch (this.props.cardType) {
                case CARD_TYPE_ENUM.FREE: {
                    if (obj.attribute != null && obj.attribute != AttrQueryField.empty_attribute) {
                        var templateID = this.props.glob.EntityModelsStore.getReferredAttributeLabel(
                            obj.attribute,
                            this.props.dataSourceID
                        );
                    }
                    obj.templateID = templateID;
                    break;
                }
                case CARD_TYPE_ENUM.BOTH_VALS_FOR_DIFF_IN_SINGLE_QUERY: {
                    if (val === 'baseForDiff' || val === 'valueForDiff') {
                        obj.readOnly = true;
                    }
                    if (roleTemplateID.query1) {
                        obj.templateID = roleTemplateID.query1[val] || val;
                    }
                    break;
                }
                case CARD_TYPE_ENUM.USE_2_SEPARATE_QUERIES: {
                    if (val === 'baseForDiff' || val === 'valueForDiff') {
                        obj.readOnly = true;
                    }
                    if (this.props.query_num === 1) {
                        if (roleTemplateID.query2) {
                            obj.templateID = roleTemplateID.query2[val] || val;
                        }
                    } else {
                        if (roleTemplateID.query1) {
                            obj.templateID = roleTemplateID.query1[val] || val;
                        }
                    }
                    break;
                }
                case CARD_TYPE_ENUM.USE_TOP2_GROUPING: {
                    if (val === 'valueForDiff' || val === 'top2toDiff' || val === 'baseForDiff') {
                        obj.readOnly = true;
                    }
                    if (roleTemplateID.query1) {
                        obj.templateID = roleTemplateID.query1[val] || val;
                    }
                    break;
                }
            }
        }

        if (val === 'none') {
            delete obj.role;
        } else {
            obj.role = val;
        }

        this.handleOnValueChange(obj);
    };

    handleOnValueChange = (value: IAttrQuery) => {
        this.normalize(value);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.index);
        }
    };

    handleOnRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.index);
        }
    };

    handleAddVariableClick = () => {
        const value: IAttrQuery = {
            attribute: '',
            valueType: 'variable',
            controlType: ATTRIBUTE_CONTROL_TYPES.DECIMAL,
            type: ATTRIBUTE_TYPES.REAL,
            role: 'deltaPercent'
        };

        this.normalize(value);
        this.processOnAdd(undefined, undefined, value);
    };

    handleOnVariableChange = (value: string) => {
        const valueCopy = this.getValueCopy();

        valueCopy.attribute = value.trim();
        this.handleOnValueChange(valueCopy);
    };

    getAttribute(attrQuery: IAttrQuery) {
        const isEmpty = this.isEmpty(attrQuery);
        const emptyAttrTitle = isEmpty ? null : AttrQueryField.empty_attribute;

        let value: string | IExpression;

        if (attrQuery.expression != null) {
            value = attrQuery.expression;
        } else if (attrQuery.attribute != null) {
            value = attrQuery.attribute !== AttrQueryField.empty_attribute ? attrQuery.attribute : null;
        }

        let tree =
            this.props.cardType === CARD_TYPE_ENUM.FREE
                ? this.props.entitiesTree
                : [
                      {
                          id: '#Delta',
                          name: '#Delta',
                          expandable: false,
                          children: []
                      } as ITreeItem,
                      {
                          id: '#DeltaPCT',
                          name: '#DeltaPCT',
                          expandable: false,
                          children: []
                      } as ITreeItem
                  ].concat(this.props.entitiesTree);

        return (
            <AttributeDesigner
                tree={tree}
                dataSourceID={this.props.dataSourceID}
                modes={['attribute', 'expression']}
                value={value}
                emptyValueTitle={emptyAttrTitle}
                collapsedDict={this.props.entityCollapsedDict}
                showRemoveButtonAlways={!isEmpty}
                multiselect={isEmpty}
                validEntities={this.props.validEntities}
                tabID={this.props.tabID}
                glob={this.props.glob}
                onVariableNameChange={this.handleOnVariableChange}
                onChange={this.getAttributeOnChangeHandlter(isEmpty)}
                onExpressionChange={this.getExpressionOnChangeHandlter(isEmpty)}
                onCollapsedDictChange={this.props.onEntityCollapsedDictChange}
                onRemove={this.handleOnRemove}
            />
        );
    }

    isEmpty = (value: IAttrQuery) => {
        return this.props.isEmpty === true || value == null || (value.attribute == null && value.expression == null);
    };

    getAggregate = (value: IAttrQuery) => {
        if (this.isEmpty(value) || value.attribute === '#DeltaPCT' || value.attribute === '#Delta') {
            return;
        }

        const attributeType = getAttributeType(value, this.props.glob, this.props.dataSourceID);
        const options = _.map(AGGREGATE_GROUP_VALUES[attributeType], (value, i) => {
            return (
                <option key={value + '-' + i} value={value}>
                    {value}
                </option>
            );
        });

        const aggregate = value.aggregateGroup || 'none';

        return (
            <SelectField value={aggregate} onChange={this.handleOnAggregateChange}>
                <option key="none" value="none">
                    {'none'}
                </option>

                {options}
            </SelectField>
        );
    };

    getSortingSelect(value) {
        if (value.attribute == null && value.expression == null) {
            return;
        }

        return (
            <AttributeSortingSelect
                value={value}
                onChange={this.handleOnValueChange}
                onSortOrderSet={this.handleSortOrderChange}
            />
        );
    }

    getIntervals = (value) => {
        if (this.isEmpty(value)) {
            return;
        }

        let attributeType = getAttributeType(value, this.props.glob, this.props.dataSourceID) ?? ATTRIBUTE_TYPES.STRING;

        if (AttrQueryValuesFormat.isCountAggregate(value)) {
            attributeType = ATTRIBUTE_TYPES.INTEGER;
        }

        if (
            attributeType === ATTRIBUTE_TYPES.ENUMERATION ||
            attributeType === ATTRIBUTE_TYPES.BOOLEAN ||
            attributeType === 'none'
        ) {
            return;
        }

        //EVG: See Issue 95479. VR suggested that Cards should have no limitation for targetTypes.
        //let targetTypes = [DiscreteIntervalsKind.icon, DiscreteIntervalsKind.label, DiscreteIntervalsKind.color];

        return (
            <IntervalsSelect
                value={value.intervals}
                type={attributeType}
                withMappings={true}
                mapping={value.mapping}
                //targetTypes={targetTypes}
                themeObj={this.props.theme}
                glob={this.props.glob}
                onChange={this.processIntervalsChange}
            />
        );
    };

    getFormatFront = (value: IAttrQuery) => {
        if (this.isEmpty(value)) {
            return;
        }

        const attributeType = getAttributeType(value, this.props.glob, this.props.dataSourceID);

        let customizeFormat = true;

        if (value.aggregateGroup != undefined && value.aggregateGroup == 'count') {
            customizeFormat = true;
        } else {
            customizeFormat = formatIsCustomizable(attributeType);
        }

        if (value.role == 'ID') {
            return;
        }

        return (
            <FormatChooser
                isScalar={true}
                value={value}
                theme={this.props.theme}
                dataSourceID={this.props.dataSourceID}
                customizeFormat={customizeFormat}
                showStyle={true}
                showTemplate={true}
                showRawTemplate={false}
                glob={this.props.glob}
                getDefaultAttributeType={(value: IAttributeName) => {
                    return getDefaultAttributeType(value, this.props.glob, this.props.dataSourceID);
                }}
                onChange={this.handleFormatFrontChange}
            />
        );
    };

    getTemplateID(value: IAttrQuery) {
        if (this.isEmpty(value)) {
            return;
        }

        let placeholder = '';

        if (value.templateID == null || value.templateID === '') {
            if (value.attribute != null && value.attribute !== AttrQueryField.empty_attribute) {
                placeholder = makeDefaultCustomID(value.attribute);
            }
        }

        return (
            <StringField
                value={value.templateID}
                placeholder={placeholder}
                readOnly={value.readOnly}
                onChange={this.handleOnTemplateIDChange}
            />
        );
    }

    getLabel(value: IAttrQuery) {
        if (
            this.isEmpty(value) ||
            ((value.role === 'top2toDiff' || value.role === 'valueForDiff') &&
                this.props.cardType === CARD_TYPE_ENUM.USE_TOP2_GROUPING)
        ) {
            return;
        }

        let placeholder = '';

        if (
            value.attribute != null &&
            value.attribute !== AttrQueryField.empty_attribute &&
            value.attribute !== '#Delta' &&
            value.attribute !== '#DeltaPCT'
        ) {
            placeholder = this.props.glob.EntityModelsStore.getReferredAttributeLabel(
                value.attribute,
                this.props.dataSourceID
            );
        }

        return <StringField value={value.label || ''} placeholder={placeholder} onChange={this.handleOnLabelChange} />;
    }

    getRole(value: IAttrQuery) {
        if (this.isEmpty(value)) {
            return;
        }

        const roleValuesList = this.props.RoleValuesList;
        const customRoles = _.chain(this.state.customRoles)
            .filter((r) => {
                return r != null;
            })
            .map((r) => {
                return { text: r, val: r };
            })
            .value();

        // let customRoles = _.map(this.state.customRoles, (r) => {
        //     return { text: r, val: r };
        // })

        const roleHash = _.indexBy(_.sortBy(roleValuesList.concat(customRoles), 'text'), 'val');
        const displayValues = convertFromHashToDisplayValues(roleHash, 'text');

        return (
            <SuggestionSelect
                value={value.role != null ? [value.role] : null}
                displayValues={displayValues}
                singleSelectMode={true}
                keySelect={true}
                allowNull={false}
                allowAdding={true}
                theme={this.props.theme}
                glob={this.props.glob}
                getValues={this.getValuesForRoleSelect}
                onChange={this.processRoleChange}
            />
        );
    }

    getValuesForRoleSelect = (): GetValuesResult => {
        const result = $.Deferred<IGetValuesResult>();

        const customRoles = _.chain(this.state.customRoles)
            .filter((r) => {
                return r != null;
            })
            .map((r) => {
                return { text: r, val: r };
            })
            .value();

        const valuesHash = _.indexBy(_.sortBy(this.props.RoleValuesList.concat(customRoles), 'text'), 'val');

        const displayValues: IDisplayValue[] = [];

        _.each(valuesHash, (value, key) => {
            displayValues.push({
                value: key,
                displayValue: value.text
            });
        });

        result.resolve({
            displayValues: displayValues
        });

        return result;
    };

    getOptionsSelect(value) {
        let tree =
            this.props.cardType === CARD_TYPE_ENUM.FREE
                ? this.props.entitiesTree
                : [
                      {
                          id: '#Delta',
                          name: '#Delta',
                          expandable: false,
                          children: []
                      } as ITreeItem,
                      {
                          id: '#DeltaPCT',
                          name: '#DeltaPCT',
                          expandable: false,
                          children: []
                      } as ITreeItem
                  ].concat(this.props.entitiesTree);

        if (value == null || (value.attribute == null && value.expression == null)) {
            return;
        }

        if (value.attribute === '#Delta' || value.attribute === '#DeltaPCT') {
            return;
        }

        return (
            <AttributeOptionsSelect
                value={value}
                dataSourceID={this.props.dataSourceID}
                entitiesTree={tree}
                //entityCollapsedDict={ this.props.entityCollapsedDict }
                tabID={this.props.tabID}
                glob={this.props.glob}
                onChange={this.handleOnValueChange}
                //onEntityCollapsedDictChange={ this.props.onEntityCollapsedDictChange }
            />
        );
    }

    render() {
        const value: IAttrQuery = this.props.value || {};

        return (
            <tr className={this.props.isEmpty ? 'empty' : 'attribute-row'}>
                <td className="cell-attribute">{this.getAttribute(value)}</td>

                <td className="cell-group-aggregate">{this.getAggregate(value)}</td>

                <td className="cell-sorting">{this.getSortingSelect(value)}</td>

                <td className="cell-intervals">{this.getIntervals(value)}</td>

                <td className="cell-format">{this.getFormatFront(value)}</td>

                <td className="cell-options">{this.getOptionsSelect(value)}</td>

                <td className="cell-label">{this.getLabel(value)}</td>

                {this.props.cardType != null && this.props.cardType != CARD_TYPE_ENUM.FREE ? (
                    <td className="cell-role">{this.getRole(value)}</td>
                ) : (
                    <td className="cell-template-id">{this.getTemplateID(value)}</td>
                )}
            </tr>
        );
    }
}

export default class AttrQueryField extends React.Component<
    AttrQueryFieldProperties,
    {
        select;
        entityCollapsedDict: IToggleStates;
        customRoles: string[];
    }
> {
    private static startIndex;
    public static empty_attribute = 'select attribute';

    private references: {
        tableBody?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = {
            select: null,
            entityCollapsedDict: {},
            customRoles: this.collectCustomRoles(props.value)
        };
    }

    collectCustomRoles = (values: IAttrQuery[]): string[] => {
        let result = _.chain(values)
            .filter((v) => {
                return !_.contains(STANDARD_ROLES, v.role);
            })
            .map((x) => {
                return x.role;
            })
            .value();

        return result;
    };

    reorderStart = (e, ui) => {
        AttrQueryField.startIndex = $(ui.item).index();
    };

    reorderStop = (e, ui) => {
        if (AttrQueryField.startIndex == null) {
            return;
        }

        const startIndex = AttrQueryField.startIndex;
        const stopIndex = $(ui.item).index();

        AttrQueryField.startIndex = null;

        let tableBody = this.references.tableBody;
        $(tableBody).sortable('cancel');

        this.processReorder(startIndex, stopIndex);
    };

    componentDidMount() {
        this.props.glob.EntityModelsActions.loadModels();
        this.props.glob.EntityModelsStore.addOnDataLoadListener(this.handleOnEntityModelsChange);

        let tableBody = this.references.tableBody;

        $(tableBody).sortable({
            axis: 'y',
            forceHelperSize: true,
            items: 'tr.attribute-row:not(.empty)',
            opacity: 0.8,
            handle: '.cell-attribute',
            cursor: 'grabbing',

            start: this.reorderStart,
            stop: this.reorderStop
        });
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeOnDataLoadListener(this.handleOnEntityModelsChange);

        let tableBody = this.references.tableBody;
        if (tableBody != null) {
            $(tableBody).sortable('destroy');
        }
    }

    handleOnEntityModelsChange = (eventType: DataloadEventTypes) => {
        if (eventType === DataloadEventTypes.MODEL) {
            this.setState(this.state);
        }
    };

    processReorder(start, stop) {
        if (start === stop) {
            return;
        }

        let value = [...this.props.value];

        const item = value.splice(start, 1);
        value.splice(stop, 0, item[0]);

        this.processValueChange(value);
    }

    processValueChange(value) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    handleEntityCollapsedDictChange = (value) => {
        this.setState({ entityCollapsedDict: value });
    };

    handleAddRow = (checkedItems: string[], expression: IExpression) => {
        const values = [...this.props.value];

        if (checkedItems != null) {
            _.each(checkedItems, (attribute) => {
                const value: IAttrQuery = {
                    attribute: attribute,
                    attrType: getAttributeType(attribute, this.props.glob, this.props.dataSourceID)
                };

                values.push(value);
            });
        } else if (expression != null) {
            const value: IAttrQuery = {
                expression: expression
            };

            values.push(value);
        }
        this.processValueChange(values);
    };

    handleChangeRow = (obj: IAttrQuery, index: number) => {
        let arr = [...this.props.value];
        const prev = arr.splice(index, 1, obj)[0];

        if (prev.sort == null && obj.sort != null) {
            processSortSet(index, null, arr);
        }

        normalizeSorting(arr);
        this.processValueChange(arr);
    };

    handleRemoveRow = (i) => {
        let arr = this.props.value.slice(0);

        arr.splice(i, 1);
        normalizeSorting(arr);
        this.processValueChange(arr);
    };

    handleAddCustomRole = (role) => {
        let roles = this.state.customRoles;

        if (!_.contains(roles, role)) {
            roles.push(role);
            this.setState({
                customRoles: roles
            });
        }
    };

    handleSortSet = (i, order) => {
        var arr = this.props.value.slice(0);

        processSortSet(i, order, arr);
        this.processValueChange(arr);
    };

    render() {
        const { dataSourceID } = this.props;
        const entitiesTree = this.props.glob.EntityModelsStore.getEntitiesTreeByDS(dataSourceID);
        const attributesCount = this.props.value != null ? this.props.value.length : 0;
        const { cardType } = this.props.options;
        const roleValuesList = [];

        _.each(this.props.options.RoleValuesList, (value: any, key: string) => {
            roleValuesList.push({ text: value, val: key });
        });

        var mySelector = '.form-control';
        var styleSheets: any = window.document.styleSheets;
        var defaultColor;

        for (let i = 0; i < styleSheets.length; i++) {
            if (classes) {
                var classes = styleSheets[i].rules || styleSheets[i].cssRules;

                for (let x = 0; x < classes.length; x++) {
                    var matchClass = false;

                    if (classes[x].selectorText === mySelector) {
                        //exact match
                        matchClass = true;
                    }

                    if (matchClass) {
                        let st = classes[x].style;

                        if (st != null) {
                            let color = st.color;

                            if (color != null) {
                                defaultColor = color;
                            }
                        }
                    }
                }
            }
        }

        if (defaultColor == null) {
            defaultColor = '#555555';
        }

        const rows = _.map(this.props.value, (obj, index) => {
            if (
                this.props.options.RoleValuesList &&
                this.props.options.RoleValuesList[obj.role] == null &&
                !_.contains(this.state.customRoles, obj.role)
            ) {
                delete obj.role;
            }

            return (
                <AttrQueryFieldRow
                    key={obj.id}
                    index={index}
                    query_num={this.props.query_num}
                    maxIndex={attributesCount - 1}
                    customRoles={this.state.customRoles}
                    RoleValuesList={roleValuesList}
                    Role_TemplateID={this.props.options.Role_TemplateID}
                    RoleValuesListFull={this.props.options.RoleValuesListFull}
                    entitiesTree={entitiesTree}
                    cardType={cardType}
                    value={obj}
                    theme={this.props.themeObj}
                    entityCollapsedDict={this.state.entityCollapsedDict}
                    dataSourceID={dataSourceID}
                    validEntities={this.props.validEntities}
                    tabID={this.props.tabID}
                    defaultColor={defaultColor}
                    glob={this.props.glob}
                    onEntityCollapsedDictChange={this.handleEntityCollapsedDictChange}
                    onAddCustomRole={this.handleAddCustomRole}
                    onChange={this.handleChangeRow}
                    onRemove={this.handleRemoveRow}
                    onSortSet={this.handleSortSet}
                />
            );
        });

        return (
            <div className={'attrquery-card-field'}>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="cell-attribute">{'Attribute'}</th>
                            <th className="cell-group-aggregate">{'Aggregation'}</th>

                            <th className="cell-sorting">
                                <AttributeSortingSelectHeader />
                            </th>

                            <th className="cell-intervals">{'Mappings'}</th>

                            <th className="cell-format">{'Format'}</th>

                            <th className="cell-options" title={'More Options'}>
                                {'More...'}
                            </th>

                            <th className="cell-label">{'Label'}</th>

                            {cardType != null && cardType !== CARD_TYPE_ENUM.FREE ? (
                                <th className="cell-role">{'Role ID'}</th>
                            ) : (
                                <th className="cell-template-id">{'ID'}</th>
                            )}
                        </tr>
                    </thead>

                    <tbody
                        ref={(input) => {
                            this.references.tableBody = input;
                        }}
                    >
                        {rows}

                        <AttrQueryFieldRow
                            entitiesTree={entitiesTree}
                            entityCollapsedDict={this.state.entityCollapsedDict}
                            dataSourceID={dataSourceID}
                            isEmpty={true}
                            defaultColor={defaultColor}
                            validEntities={this.props.validEntities}
                            cardType={cardType}
                            tabID={this.props.tabID}
                            customRoles={this.state.customRoles}
                            theme={this.props.themeObj}
                            glob={this.props.glob}
                            onEntityCollapsedDictChange={this.handleEntityCollapsedDictChange}
                            onAdd={this.handleAddRow}
                        />
                    </tbody>
                </table>
            </div>
        );
    }
}
